import { ModalCloseButton, ModalOverlay } from './Modal';
import styles from './styles/PickEmModal.module.scss';
import Button, { ButtonVariant, ButtonWidth } from './Button';
import PlayoffPickEmModalLogo from '../../../assets/images/playoff-pick-em-white.png';
import Image from 'components/Image';

interface PickEmModalProps {
  bracketWebPath?: string;
  onClose: () => void;
  subtitle?: string;
  bodyText: string;
  buttonText: string;
  onButtonClick?: () => void;
}

function PickEmModal({ bracketWebPath, onClose, subtitle, bodyText, buttonText, onButtonClick }: PickEmModalProps) {
  return (
    <ModalOverlay onClose={onClose} overlayClassName={styles.ModalContainer}>
      <div className={styles.ModalBackground}>
        <div className={styles.ModalContents}>
          <ModalCloseButton onClose={onClose} className={styles.ModalClose} />
          <Image src={PlayoffPickEmModalLogo} className={styles.ModalLogo} />
          {subtitle && <div className={styles.ModalSubtitleText}>{subtitle}</div>}
          <div className={styles.ModalBodyText}>{bodyText}</div>
          <Button
            variant={ButtonVariant.WHITE}
            width={ButtonWidth.FULL}
            className={styles.ModalButton}
            {...(bracketWebPath ? { href: bracketWebPath } : { onClick: onButtonClick || onClose })}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </ModalOverlay>
  );
}

export default PickEmModal;
